import React, { Component } from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { getDmService } from '../../services/Api';

class UnidAndStores extends Component {
  constructor(props) {
    super(props);

    this.state = {
      units: [],
      // stores: [],
      // list: props.list || [],
      // error: null,
    };
  }

  static propTypes = {
    onChangeStore: PropTypes.func,
    onChangeUnit: PropTypes.func,
  };

  static defaultProps = {
    onChangeStore: () => null,
    onChangeUnit: () => null,
  };

  componentDidMount() {
    this.loadUnits();
  }

  loadUnits = async () => {
    const { urlUnits } = this.props;
    try {
      const data = await getDmService(urlUnits);
      this.setState({
        units: data.map(item => ({ id: item.id, label: item.nome })),
      });
    } catch (error) {
      console.error(error);
    }
  };

  render() {
    const { units } = this.state;
    const {
      onChangeUnit, onChangeStore, selectedUnit, selectedStore, stores,
    } = this.props;

    return (
      <div>
        <div className="bx--row">
          <div className="bx--col-xs-10 bx--col-sm-5">
            <label className="v-sm-margin">Unidade</label>
            <Select
              className="search-dm"
              name="units"
              options={units}
              value={selectedUnit}
              onChange={onChangeUnit}
              placeholder="Digite o código ou selecione"
              isClearable={false}
              isSearchable
            />
          </div>
          <div className="bx--col-xs-10 bx--col-sm-5">
            <label className="v-sm-margin">Loja</label>
            <Select
              className="search-dm"
              name="stores"
              options={stores}
              value={selectedStore}
              onChange={onChangeStore}
              placeholder="Digite o código ou selecione"
              isClearable={false}
              isSearchable
            />
          </div>
        </div>
      </div>
    );
  }
}

export default UnidAndStores;



// WEBPACK FOOTER //
// ./src/components/trades/UnitsAndStores.js